import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import { TOfferSetType } from './getOfferSetType';
import { FundingProgressIndicator } from '../../../../funding/fundingSteps/FundingProgessIndicator/FundingProgressIndicator';
import { FlexiApprovedView } from '../../../approvedView/flexiApprovedView/FlexiApprovedView';

export const LegacyOfferPage = ({
    offerSetType
}: {
    offerSetType: NonNullable<TOfferSetType>;
}) => {
    useEffect(() => {
        tracking.ampli.approvedViewVisited({
            status: offerSetType,
            offers_page_version: '1.0'
        });
    }, [offerSetType]);

    return (
        <>
            <FundingProgressIndicator step={1} />
            <FlexiApprovedView />
        </>
    );
};
